var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v("© 2021 OGOPOGO 粤ICP备2021086955号")])])}]

export { render, staticRenderFns }